module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-content m-t-xl b-gray-1 pay-success-wrp"
  }, [_c('div', {
    staticClass: "bg-gray-4 pay-success-header"
  }, [_c('img', {
    staticClass: "pay-scucess-img",
    attrs: {
      "src": require("../assets/fin.png")
    }
  }), _vm._v(_vm._s(_vm.orderPayStatus) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "pay-success-body text-big"
  }, [_c('ul', {
    staticClass: "pay-success-ul"
  }, [_c('li', [_vm._v("付款方式："), _c('span', {
    staticClass: "text-price"
  }, [_vm._v(_vm._s(_vm.orderPayTypes[_vm.order.orderPay.payMethod]))])]), _vm._v(" "), _c('li', [_vm._v("订单金额: "), _c('span', {
    staticClass: "text-price"
  }, [_vm._v("￥" + _vm._s(_vm.order.price / 100 || ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-list-link-wrp"
  }, [_vm._v("您可以查看:  "), _c('router-link', {
    staticClass: "link-text",
    attrs: {
      "to": {
        name: 'OrderList'
      }
    }
  }, [_vm._v("我的订单")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-success-tip"
  }, [_c('span', {
    staticClass: "text-price"
  }, [_vm._v("安全提醒：")]), _vm._v(" 安全提醒：下单成功后，时尚新娘不会以订单异常、系统升级等问题为由，要求您点击任何链接进行退款操作。请谨防诈骗！\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfe1eee8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaySuccess.vue
// module id = 612
// module chunks = 1